import { render } from "./ProduitPosteLettrePage.vue?vue&type=template&id=7a4c24c9"
import script from "./ProduitPosteLettrePage.vue?vue&type=script&lang=js"
export * from "./ProduitPosteLettrePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__